import type { ThemeSettings } from '../types';

export const internalLinkStyle = ({ palette = {}, elementLocator = 'a', isGreyBackground = false }: ThemeSettings) => ({
  [`& ${elementLocator}`]: {
    textDecoration: 'none',
    color: isGreyBackground ? palette.themeDarkAlt : palette.themePrimary,
    '&:focus': {
      textDecoration: 'none',
      outline: `1px solid ${palette.neutralSecondary}`,
    },
    '&:hover': {
      textDecoration: 'underline',
      color: palette.themeDarker,
    },
  },
});
